import React from "react";
import UpgradeToSeeMoreButton from "./UpgradeToSeeMoreButton";

export interface UpgradeBlurOverlayProps {
  isLocked: boolean;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  buttonSize?: "sm" | "md" | "lg";
  minHeight?: number | string;
}

export default function UpgradeBlurOverlay({
  isLocked,
  children,
  className = "",
  style,
  buttonSize = "md",
  minHeight,
}: UpgradeBlurOverlayProps) {
  if (!isLocked) {
    return <>{children}</>;
  }

  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{
        minHeight: minHeight || "auto",
        ...style,
      }}
    >
      {/* Content under overlay (non-selectable, non-clickable) */}
      <div
        style={{
          filter: "blur(4px)",
          WebkitFilter: "blur(4px)",
          pointerEvents: "none",
          userSelect: "none",
          WebkitUserSelect: "none",
          opacity: 0.82,
        }}
        aria-hidden="true"
      >
        {children}
      </div>

      {/* FalconFeeds upgrade_premium_bg backdrop overlay */}
      <div
        className="upgrade_premium_bg upgrade-premium-bg absolute w-[105%] h-[100%] top-0 left-[-20px] z-40 pointer-events-none"
        style={{
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
          background: "rgba(10, 10, 11, 0.4)",
        }}
      />

      {/* FalconFeeds centered upgrade button container */}
      <div
        className="w-full h-full absolute inset-0 z-40 flex items-center justify-center pointer-events-auto"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div style={{ width: "198px" }} className="mx-auto flex justify-center">
          <UpgradeToSeeMoreButton size={buttonSize} />
        </div>
      </div>
    </div>
  );
}
